import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaWhatsapp, FaMapMarkerAlt, FaPhone, FaEnvelope, FaCar } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // Social media links with valid URLs
  const socialLinks = [
    { 
      icon: <FaFacebook />, 
      url: 'https://facebook.com/leodroptaxi', 
      label: 'Facebook',
      color: '#1877f2'
    },
    { 
      icon: <FaInstagram />, 
      url: 'https://instagram.com/leodroptaxi', 
      label: 'Instagram',
      color: '#e4405f'
    },
    { 
      icon: <FaWhatsapp />, 
      url: 'https://wa.me/917907172520', 
      label: 'WhatsApp',
      color: '#25d366'
    }
  ];

  return (
    <footer className="bg-dark text-white pt-5 pb-3">
      <Container>
        <Row className="gy-4">
          <Col lg={4} md={6}>
            <h4 className="text-white mb-2">
              <FaCar className="text-warning me-2" />
              Lexus Drop Taxi
            </h4>
            <span
              aria-hidden="true"
              style={{
                display: 'block',
                width: '52px',
                height: '4px',
                background: '#FFD700',
                borderRadius: '999px',
                marginBottom: '1rem'
              }}
            />
            <p className="text-light">
              At Lexus DROP TAXI, your safety, comfort, and punctuality are our top priorities.
            </p>
            <p className="text-light">
              Since 2023, we&apos;ve been proudly serving customers across{' '}
              <span className="text-warning fw-semibold">Tamilnadu, Kerala, Andhra Pradesh, Karnataka, and Pondicherry.</span>
            </p>
            <p className="text-light">
              Thank you for trusting us to be a part of your everyday journeys.
            </p>
            
            {/* Social Links with valid href */}
            <div className="d-flex gap-3 mt-3 footer-social-links justify-content-md-start">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-flex align-items-center justify-content-center rounded-circle"
                  style={{
                    width: '40px',
                    height: '40px',
                    backgroundColor: social.color,
                    color: 'white',
                    transition: 'all 0.3s ease',
                    textDecoration: 'none'
                  }}
                  aria-label={social.label}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = '0 5px 10px rgba(0,0,0,0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </Col>

          <Col lg={2} md={6}>
            <h4 className="text-white mb-4">Quick Links</h4>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/" className="text-light text-decoration-none hover-warning">Home</Link>
              </li>
              <li className="mb-2">
                <Link to="/tariff" className="text-light text-decoration-none hover-warning">Tariff</Link>
              </li>
              <li className="mb-2">
                <Link to="/popular-routes" className="text-light text-decoration-none hover-warning">Popular Routes</Link>
              </li>
              <li className="mb-2">
                <Link to="/customer-info" className="text-light text-decoration-none hover-warning">Customer Info</Link>
              </li>
              <li className="mb-2">
                <Link to="/about" className="text-light text-decoration-none hover-warning">About Us</Link>
              </li>
              <li className="mb-2">
                <Link to="/contact" className="text-light text-decoration-none hover-warning">Contact</Link>
              </li>
            </ul>
          </Col>

          <Col lg={3} md={6}>
            <h4 className="text-white mb-4">Our Services</h4>
            <ul className="list-unstyled">
              <li className="mb-2 text-light">
                <span className="text-warning me-2">🚗</span> One Way Trips
              </li>
              <li className="mb-2 text-light">
                <span className="text-warning me-2">🔄</span> Round Trips
              </li>
              <li className="mb-2 text-light">
                <span className="text-warning me-2">🏔️</span> Hill Station Trips
              </li>
              <li className="mb-2 text-light">
                <span className="text-warning me-2">✈️</span> Airport Transfers
              </li>
              <li className="mb-2 text-light">
                <span className="text-warning me-2">🚐</span> Corporate Travel
              </li>
              <li className="mb-2 text-light">
                <span className="text-warning me-2">👨‍👩‍👧</span> Family Tours
              </li>
              <li className="mb-2 text-light">
                <span className="text-warning me-2">🗺️</span> Tour Packages
              </li>
            </ul>
          </Col>

          <Col lg={3} md={6}>
            <h4 className="text-white mb-4">Contact Info</h4>
            <div className="d-flex mb-3">
              <FaMapMarkerAlt className="text-warning me-3 mt-1" size={20} />
              <span className="text-light">
                1-3-221, Kollam Main Road, Puliyarai,<br />
                Sengottai, Tenkasi - 627813.
              </span> 
            </div>
            <div className="d-flex mb-3">
              <FaPhone className="text-warning me-3 mt-1" size={20} />
              <span className="text-light">
                <a href="tel:+918148111516" className="text-light text-decoration-none hover-warning d-block">
                  +91 8148111516
                </a>
                
              </span>
            </div>
            <div className="d-flex mb-3">
              <FaEnvelope className="text-warning me-3 mt-1" size={20} />
              <span className="text-light">
                <a href="mailto:lexusno1taxi@gmail.com" className="text-light text-decoration-none hover-warning d-block">
                  lexusno1taxi@gmail.com
                </a>
                
              </span>
            </div>
          </Col>
        </Row>

        <hr className="bg-secondary" />

        <Row> <Col className="text-center" > <p className="text-light mb-0 small"> &copy; {currentYear} Lexus Drop Taxi. All rights reserved. | 
          <span className="text-warning ms-2"> 
            Developed by{' '} <a href="tel:+91" 
            className="text-warning text-decoration-none hover-warning" style={{ cursor: 'pointer' }} >
               lexus drop taxi</a> </span> 
               </p> </Col> </Row>
      </Container>

      {/* Custom CSS for hover effects */}
      <style>{`
        .hover-warning:hover {
          color: #ffc107 !important;
          transition: color 0.3s ease;
        }
      `}</style>
    </footer>
  );
};

export default Footer;
